import AfterLoginGuard from "../../guards/AfterLoginGuard";
import MyMultiStepForm from "./Profile";
import ProtectedRoute from "../../guards/ProtectedRoute";

const researchProfileRoutes = [
  {
    path: "/profile",
    element: <AfterLoginGuard />,
    children: [
      {
        path: "",
        element: (
          <ProtectedRoute
            element={<MyMultiStepForm />}
            permissions={["/auth/home"]}
          />
        ),
      },
      {
        path: "form",
        element: (
          <ProtectedRoute
            element={<MyMultiStepForm />}
            permissions={["/auth/home"]}
          />
        ),
      },
    ],
  },
];

export default researchProfileRoutes;
//
// export const researchProfileItems = [{
//         name: 'auth.subsystems',
//         route: '/profile/form',
//         icon: 'widgets',
//         iconType: 'MAT',
//         permissions:['/auth/home']
//     }]
